<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>客户电量申报管理 </el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.back()">返回</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="formBox">
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   :rules="rules"
                   label-position="left"
                   style="padding:20px;background:#fff"
                   label-width="180px">
            <el-row :gutter="60">
              <el-col :span="12">
                <el-form-item label="客户名称：">
                  <el-select v-model="form.clientName"
                             @change="changeEnterprise"
                             placeholder="请选择">
                    <el-option v-for="item in clientNames"
                               :key="item.clientId"
                               :label="item.clientName"
                               :value="item.clientName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申报状态：">
                  <el-select v-model="form.declareStatus"
                             placeholder="请选择">
                    <el-option label="未开始"
                               :value="1"></el-option>
                    <el-option label="申报中"
                               :value="2"></el-option>
                    <el-option label="已申报"
                               :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="用户类型："
                              prop="userType">
                  <el-input v-model="form.userType"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域："
                              prop="areaCode">
                  <el-select v-model="form.areaCode"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in provinces"
                               :key="item.code"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易员：">
                  <el-select v-model="form.traderId"
                             filterable
                             clearable
                             @change="changeTraderName"
                             placeholder="交易员">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="交易员电话："
                              required>
                  <el-input v-model="form.traderPhone"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="销售负责人: ">
                  <el-select v-model="form.saleId"
                             filterable
                             clearable
                             @change="changeSalesmanname"
                             placeholder="销售负责人">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="销售电话："
                              required>
                  <el-input v-model="form.salePhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商："
                              required>
                  <el-select v-model="form.agentId"
                             filterable
                             clearable
                             @change="changeAgentnname"
                             placeholder="销售负责人">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商电话：">
                  <el-input v-model="form.agentPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="ax_default line1"></div>
            <el-form-item>
              <div style="text-align:center">
                <el-button @click="$router.back()">取消</el-button>
                <el-button @click="submitForm('form')"
                           type="primary">保存</el-button>
              </div>

            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getprovince, postclientPowerDeclare, putclientPowerDeclare, getUserNames, getclientNames } from '../../API'
export default {
  data () {
    return {
      name: '新增',
      form: {
        agent: "",
        agentId: '',
        agentPhone: "",
        area: "",
        areaCode: "",
        clientId: '',
        clientName: "",
        powerDeclareId: '',
        saleId: '',
        saleName: "",
        salePhone: "",
        trader: "",
        traderId: '',
        traderPhone: "",
        userType: '',
      },
      rules: {
        areaCode: { required: true, message: '必填', trigger: 'blur' },
        cityCode: { required: true, message: '必填', trigger: 'blur' },
        provinceCode: { required: true, message: '必填', trigger: 'blur' },
        contractNumber: { required: true, message: '必填', trigger: 'blur' },
        powerDeviationRate: { required: true, message: '必填', trigger: 'blur' },
        contacts: { required: true, message: '必填', trigger: 'blur' },
        contractName: { required: true, message: '必填', trigger: 'blur' },
        contactsNumber: { required: true, message: '必填', trigger: 'blur' },
        contractStatus: { required: true, message: '必填', trigger: 'blur' },
        signDate: { required: true, message: '必填', trigger: 'blur' },
        endDate: { required: true, message: '必填', trigger: 'blur' },
        terms: { required: true, message: '必填', trigger: 'blur' },
        transactionStatus: { required: true, message: '必填', trigger: 'blur' },
        contractPrice: { required: true, message: '必填', trigger: 'blur' },
        shareRatio: { required: true, message: '必填', trigger: 'blur' },
      },
      provinces: [],
      username: [],
      clientNames: [],
      userNames:[]
    }
  },
  created () {
    if (localStorage.getItem('khsbgl')) {
      this.form = JSON.parse(localStorage.getItem('khsbgl'))
      this.name = '修改'
    }
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
    getUserNames().then(res => {
      if (res.code === 0) {
        this.userNames = res.data
      }
    }),
    getclientNames().then(res => {
        if (res.code === 0) {
            this.clientNames = res.data
        }
    })
  },
  methods: {
    changeTraderName(data) {
        let resultArr = this.userNames.filter((item) =>{
            return item.userId === data
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.trader = resultArr[0].username
    },
    changeAgentnname(data) {
        let resultArr = this.userNames.filter((item) =>{
            return item.userId === data
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.agent = resultArr[0].username
    },
    changeSalesmanname(data) {
        let resultArr = this.userNames.filter((item) =>{
            return item.userId === data
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.saleName = resultArr[0].username
    },
    changeEnterprise(data) {
        let resultArr = this.clientNames.filter((item) =>{
            return item.clientName === data
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.clientId = resultArr[0].clientId
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('khsbgl')) {
            this.form.clientId = localStorage.getItem('id')
            this.form.area = _.find(this.provinces, { code: this.form.areaCode.toString() }).name
            // this.form.saleId = _.find(this.username, { username: this.form.saleName.toString() }).saleId
            putclientPowerDeclare(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
          else {
            let params = this.form
            this.form.area = _.find(this.provinces, { code: this.form.areaCode.toString() }).name
            // this.form.saleId = _.find(this.username, { username: this.form.saleName.toString() }).saleId
            postclientPowerDeclare(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            }).catch(err => {
              console.log(err)
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
.formBox {
  border: 1px solid #e4e4e4;
  border-top: 7px solid #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}

.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line1 {
  height: 1px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
}
/deep/ .el-input {
  width: 200px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
